export enum ToneMapping {
  LEGACY = 'LEGACY',
  LINEAR = 'LINEAR',
  NEUTRAL = 'NEUTRAL',
}
